import Vue from 'vue';
import Router from 'vue-router';
import App from './routes/app/Index';
import appRoutes from './routes/app/router';
import Login from './routes/login/Index';
// eslint-disable-next-line no-unused-vars
import store from '@/store/';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: App,
      children: appRoutes,
      beforeEnter: (to, from, next) => {
        let auth = localStorage.getItem('token');
        if (!auth) {
          store.commit('auth/logout');
          next('/login');
        } else {
          next();
        }
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
  ],
});
//
router.beforeEach(function (to, from, next) {
  let middleware;
  to.matched.some((m) => {
    middleware = m.meta.guard;
  });
  if (typeof middleware === 'undefined') {
    next();
  } else {
    if (store.getters['auth/checkPermission'](middleware)) {
      window.scrollTo(0, 0);
      next();
    } else if (localStorage.getItem('logged')) {
      next('/');
    } else {
      next('/login');
    }
  }
  store.commit('app/setBreadcrumbs', null);
  if (from.path !== '/login') {
    store.commit('app/setBackURL', from.path);
  }
});

export default router;
